import React, { useEffect, useState } from "react";

const EventsDashboard = () => {
    const [events, setEvents] = useState<any[]>([]);
    const [dailyParticipation, setDailyParticipation] = useState({});
    const [allParticipants, setAllParticipants] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchEvents = async () => {
        const baseUrl = "https://backend.mainnet.alephium.org/contract-events/contract-address/24JUGV9ek3EFXNPWqYTP9wZ4cTQ6mAhrKk6JLy4PgPpmD";
        const eventIndex = 6;
        const limit = 100;
        let fetchedEvents: any[] = [];
        let page = 1;
        let hasMore = true;

        while (hasMore) {
            const response = await fetch(`${baseUrl}/?event_index=${eventIndex}&page=${page}&limit=${limit}`);
            const data = await response.json();

            fetchedEvents = [...fetchedEvents, ...data];

            // If the number of events is less than the limit, stop fetching
            hasMore = data.length === limit;

            if (hasMore) {
                // Pause for 3 seconds before the next request
                await new Promise((resolve) => setTimeout(resolve, 3000));
            }

            page++;
        }

        setEvents(fetchedEvents);
    };

    const processEvents = () => {
        const participation = {};
        const allPart = {};

        events.forEach((event) => {
            const date = new Date(event.timestamp).toISOString().split("T")[0];
            if (!participation[date]) {
                participation[date] = new Set();
            }
            participation[date].add(event.inputAddress);
            allPart[event.inputAddress] = true;
        });

        const result = {};
        Object.keys(participation).forEach((date) => {
            result[date] = participation[date].size;
        });
        setAllParticipants(allPart);
        setDailyParticipation(result);
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchEvents();
            setLoading(false);
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (events.length > 0) {
            processEvents();
        }
    }, [events]);

    if (loading) return <div>Loading...</div>;

    return (
        <div className="p-4 bg-gray-900 text-white rounded-lg">
            <h2 className="text-xl font-bold mb-4">Total Unique: {Object.keys(allParticipants).length}</h2>
            <h2 className="text-xl font-bold mb-4">Daily Participation Overview</h2>
            <table className="w-full text-left table-auto border-collapse">
                <thead>
                    <tr className="border-b border-gray-700">
                        <th className="py-2 px-4">Date</th>
                        <th className="py-2 px-4">Participants</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(dailyParticipation).map(([date, count]) => (
                        <tr key={date} className="border-b border-gray-800">
                            <td className="py-2 px-4 text-gray-300">{date}</td>
                            <td className="py-2 px-4 text-gray-300">{count + ""}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default EventsDashboard;
